import { MentionListResponse } from './mention.model';

export const INIT_MENTION_VALUE: MentionListResponse = {
  data: [],
  meta: {
    current_page: 0,
    from: 0,
    last_page: 0,
    per_page: 0,
    to: 0,
    total: 0,
    links: [],
    path: ''
  },
} as const;
